
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const tagcategories = state => state.tagcategories;
const getsingle = state => param =>state.tagcategories.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  tagcategories,
  getsingle
};